import { render, staticRenderFns } from "./CommissionTab.vue?vue&type=template&id=1ad996ee&scoped=true"
import script from "./CommissionTab.vue?vue&type=script&lang=js"
export * from "./CommissionTab.vue?vue&type=script&lang=js"
import style0 from "./CommissionTab.vue?vue&type=style&index=0&id=1ad996ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad996ee",
  null
  
)

export default component.exports